import React from 'react';
import './PageTitle.css'

const PageTitle = ({pageTitle}) => {
    return(
        <h1 id="pageTitle" className="lunar">{pageTitle ? pageTitle : ""}</h1>
    )
}

export default PageTitle